// extracted by mini-css-extract-plugin
export var carrierIcon = "_us-0";
export var carrierLogo = "_us-1";
export var detailsSection = "_us-2";